import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { preventNodeRemovalOnType } from '@/components/ui/tiptap/plugins';

import { AudioNodeComponent, type AudioOptions } from '.';

export const AudioNode = Node.create<AudioOptions>({
  name: 'audio-node',
  group: 'block',
  atom: false,
  draggable: true,
  allowGapCursor: true,
  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },
  addProseMirrorPlugins() {
    const type = this.type;
    return [preventNodeRemovalOnType(type)];
  },

  addAttributes() {
    return {
      src: {
        default: null,
      },
      fileType: {
        default: null,
      },
      title: {
        default: null,
      },
      poster: {
        default: null,
      },
    };
  },

  selectable() {
    return this.editor?.isEditable ?? false;
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="audio-node"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        'data-type': 'audio-node',
      }),
    ];
  },

  addCommands() {
    return {
      setAudio:
        (options) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options,
          });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(AudioNodeComponent);
  },
});
